import { LANG_V2_RAT, RAT } from "../../Data/typeDirs";
import { LanguageCategory } from "./languageCategory";
import { RAT_FORM_SCHEMA} from "./utils";

export class Rating extends LanguageCategory{
  constructor(data){
    super(data)
    this.type = Rating.getTypeDir()
    this.childTypes = Rating.getChildTypes()
  }
  getDisplayText(){
    return `${this.number?`${this.number}. `: ''}${this.content}`
  }
  static getTypeDir(){ return RAT }
  static getChildTypes(){ return [] }
  static getRelType(){ return LANG_V2_RAT }

  static getFormKeys(){
    return ['content', 'number']
  }

  getFormData(){
    return LanguageCategory.getFormData(Rating, this)
  }
  
  static getParentKey(){
    return false
  }

  static getParentAddress(){
    return false
  }

  getTypeAddress(){
    return LanguageCategory.getTypeAddress(Rating)
  }
  static getTypeAddress(){
    return LanguageCategory.getTypeAddress(Rating)
  }

  static getFormColWidths(){
    return {
      number:6,
      content:6
    }
  }

  static constructFromDBData(data){
    return new Rating(super.constructFromDBData(data, Rating.getTypeDir()))
    
  }

  
  static getFormSchema(){
    return RAT_FORM_SCHEMA
  }

  static getMongooseSchema(mongoose, Schema){
    return super.getMongooseSchema(mongoose, Schema, {
      number: {type:String},
      color: {type:String}
    })
  }

}